// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-catalog-main',
    data: () => ({
        category: {},
        isLoading: false
    }),
    created() {
        this.loadCategory();
    },
    beforeMount() {
        this.$host.eventBus.on('refresh', this.loadCategory);
    },
    beforeUnmount() {
        this.$host.eventBus.off('refresh', this.loadCategory);
    },
    computed: {
        catalogID() {
            return this.$route.params.catalogID;
        },
    },
    watch: {
        "$route.params.catalogID"(value) {
            this.loadCategory();
        },
    },
    methods: {
        async loadCategory() {
            if (utils.isEmpty(this.catalogID)) {
                return;
            }
            //Args
            let tParams = Object.assign({}, this.$route.query);
            //Loading
            this.isLoading = true;
            host.api.get(`commerce/catalog/${this.catalogID}/categories`, { params: tParams })
                .then((e) => {
                if (e.status === 204) {
                    //Redirect
                    this.$router.push('/');
                    //Result
                    this.isLoading = false;
                    return;
                }
                if (!e.data) {
                    this.isLoading = false;
                    return;
                }
                //breadcrumb                        
                this.$store.commit('navigation/setBreadcrumb', e.data.breadcrumb);
                this.$host.pageMeta.title = e.data?.caption;
                //Data
                this.category = e.data;
                //Internal
                this.isLoading = false;
            })
                .catch((e) => {
                this.isLoading = false;
                host.notification.showToast(utils.getAxiosErrorMessage(e));
            });
        }
    }
});
// #endregion
